'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scrollTop = scrollTop;

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop() {
    var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
        EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW;

    if ([NARROW, EXTRA_NARROW].indexOf(_rpMqBreakpoints2.default.current().code) > -1) {
        $(document).scrollTop(0);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-modal-dropdown/lib/utils/scrollTop.js
// module id = 1515
// module chunks = 1